

import './bordlist.css';
import { CURRENT_URL } from '../../config/runtimeConfig';
import QRCode from 'react-qr-code';
import { currentStatusEnvois, typeEnvois } from '../../data';

function Bordlist({ bagages, title, getDepartureOrArrived }) {
    function checkNameSize(value) {
        if (value.length > 15)
            return value.substring(0, 13) + '..';
        else
            return value;
    }
    function checkAddressSize(value) {
        if (value.length > 38)
            return value.substring(0, 36) + '..';
        else
            return value;
    }

    return (
        <div className='bord-list' id="bord-list">
            <div className="bord-list-header">
                <div className="bord-list-title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>{title} :</span>
                </div>
                <div className="bord-list-icons">
                    <img src={`${CURRENT_URL}//nweblack.png`} />
                    <QRCode value='https://deliver.nwexpresstest.fun/login' size={70} />
                </div>
            </div>
            <div className="bord-list-content">
                <table className="bord-list-table">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nom</th>
                            <th>Tel</th>
                            <th>Adresse</th>
                            <th>Type</th>
                            <th>Obs</th>
                            <th>Signature</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            bagages.map((item, index) => (
                                <tr key={index}>
                                    <td>{`${currentStatusEnvois.filter(elem => elem.id == item.currentStatus)[0]['nom']}-${item.Envoi.id}`}</td>
                                    <td>
                                        {
                                            (getDepartureOrArrived(item) === "Arrived") ? (checkNameSize(item.Envoi.nomArrived)) : (
                                                item.Envoi.Entreprise ? (
                                                    checkNameSize(item.Envoi.Entreprise.nom)
                                                ) : (
                                                    checkNameSize(item.Envoi.User.Userinfo.nom)
                                                )
                                            )
                                        }
                                    </td>
                                    <td>
                                        {
                                            (getDepartureOrArrived(item) === "Arrived") ? (item.Envoi.tel1Arrived) : (
                                                item.Envoi.Entreprise ? (
                                                    item.Envoi.Entreprise.tel1
                                                ) : (
                                                    item.Envoi.User.Userinfo.tel1
                                                )
                                            )
                                        }
                                    </td>
                                    <td>{(getDepartureOrArrived(item) === "Arrived") ? (checkAddressSize(item.Envoi.addressArrived || "")) : (checkAddressSize(item.Envoi.addressDeparture || "")) }</td>
                                    <td>{typeEnvois.filter(ele => ele.id === item.Envoi.typeEnvoie)[0]['nom']}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div className="bord-list-footer">
                <span>Signature Livreur</span>
            </div>
        </div>
    )
}

export default Bordlist
